import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrackUserAction, TrackUserActionService } from './track-user-actions.service';

export const TRACK_USER_ACTION_INTERCEPTOR_ID = '__TrackUserAction';

/**
 * Interceptor used to track an user action it can be used in two ways:
 * 1- Setting a header with the action id as value:  {[TRACK_USER_ACTION_INTERCEPTOR_ID]: actionId }
 * 2- Sending an additional parameter in the body:  {[TRACK_USER_ACTION_INTERCEPTOR_ID]:  { actionId: number, actionDetails: object } }
 */
@Injectable()
export class MiqTrackUserActionInterceptor implements HttpInterceptor {
  constructor(private trackUserActionsServ: TrackUserActionService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // If only the actionId needs to be sent can be done by sending it as a header
    const resourceIdInHeader = req.headers.getAll(TRACK_USER_ACTION_INTERCEPTOR_ID)?.[0];
    if (resourceIdInHeader) {
      const actionId = Number(resourceIdInHeader);
      if (isNaN(actionId)) return next.handle(req);

      const payload: TrackUserAction = { actionId };
      this.trackUserActionsServ.registerAction(payload).subscribe();
      return next.handle(req);
    }

    // When the actions needs to be sent with more details then the body is used to get the object
    if (req.body?.[TRACK_USER_ACTION_INTERCEPTOR_ID]) {
      const payload = req.body[TRACK_USER_ACTION_INTERCEPTOR_ID];
      delete req.body[TRACK_USER_ACTION_INTERCEPTOR_ID];
      this.trackUserActionsServ.registerAction(payload).subscribe();
      return next.handle(req);
    }

    return next.handle(req);
  }
}
